import { render } from "./MiniMap.component.vue?vue&type=template&id=5a533ba3"
import script from "./MiniMap.component.vue?vue&type=script&lang=js"
export * from "./MiniMap.component.vue?vue&type=script&lang=js"

import "./MiniMap.component.vue?vue&type=style&index=0&id=5a533ba3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__